import { render, staticRenderFns } from "./OrderDetails.html?vue&type=template&id=7e22f5b4&scoped=true&"
import script from "./OrderDetails.js?vue&type=script&lang=js&"
export * from "./OrderDetails.js?vue&type=script&lang=js&"
import style0 from "./OrderDetails.scss?vue&type=style&index=0&id=7e22f5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e22f5b4",
  null
  
)

export default component.exports